module.exports = __webpack_public_path__ + "static/MOMO1-73d8410a947f6f945f6fee8e1883d459.jpg";